module.exports = __webpack_public_path__ + "static/scale-model-of-american-tobacco-campus-in-durham-north-carolina-a45fb2107e89fc1bc070260a568e9ff1.png";